import React, { useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { login } from '../../services/auth';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(username, password);
      onLogin();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
      <div className="login-shell">
        <div className="login-card">
          <div className="login-brand">
            <span className="login-brand-icon">&#128273;</span>
            <div className="login-brand-name">SeikoAuth</div>
            <div className="login-brand-sub">Administration</div>
          </div>
          <form onSubmit={handleSubmit}>
            {error && <div className="error-banner">{error}</div>}
            <FormGroup>
              <Label className="form-label-custom">Nom d'utilisateur</Label>
              <Input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  autoComplete="username"
                  autoFocus
                  required
              />
            </FormGroup>
            <FormGroup>
              <Label className="form-label-custom">Mot de passe</Label>
              <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="..."
                  autoComplete="current-password"
                  required
              />
            </FormGroup>
            <Button className="btn-primary w-100 mt-2" type="submit" disabled={loading} style={{ padding: '10px' }}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </div>
      </div>
  );
}